import React, { useState } from 'react'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
// import styles from './Cars.module.scss'

const Cars = () => {
  const { dictionary, records, fleetUrl } = window.carsData
  const [currentIndex, setCurrentIndex] = useState(0)

  const handleSlideChange = (swiper) => {
    setCurrentIndex(swiper.realIndex)
  }

  const swiperOptions = {
    modules: [Navigation],
    navigation: true,
    loop: true,
    onSlideChange: handleSlideChange,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      993: {
        slidesPerView: 3,
        centeredSlides: true,
      },
    },
  }

  return (
    <div className="page-container">
      <div className="s-cars">
        <div className="s-cars__header">
          <div className="titles">
            <h2 className="h2">{dictionary.title}</h2>
            <p className="pHeader">{dictionary.subtitle}</p>
          </div>
        </div>

        <Swiper {...swiperOptions}>
          {records.map((car, index) => (
            <SwiperSlide key={index}>
              <div className="s-cars__slide">
                <img
                  src={car.image.src}
                  alt={car.image.alt}
                  className="s-cars__image"
                />
                <span className="s-cars__subtitle">{car.title}</span>
              </div>
            </SwiperSlide>
          ))}
          <div className="s-cars__mob-subtitle">
            {records[currentIndex].title}
          </div>
        </Swiper>
        <a href={records[currentIndex].link} className="btn btn-primary">
          {dictionary.seeAllBtn}
        </a>
      </div>
    </div>
  )
}

export default Cars
